/**
 * Language dropdown: closing behaviour.
 *
 * lottery-core's language-selector renders a <details> element, which opens and
 * closes itself on its <summary> with no script at all. What the browser does
 * NOT do is close it when the visitor clicks elsewhere or presses Escape, which
 * is what a dropdown is expected to do — so that is all this adds. Purely an
 * enhancement: without it the control still works, it just stays open until
 * clicked again.
 */
export default function initLanguageSelect(): void {
    const dropdowns = Array.from(document.querySelectorAll<HTMLDetailsElement>('details.language-select'));

    if (!dropdowns.length) {
        return; // translation is off for this site — the component rendered nothing
    }

    const closeAll = (except: Element | null = null): void => {
        dropdowns.forEach((dropdown) => {
            if (dropdown !== except) {
                dropdown.removeAttribute('open');
            }
        });
    };

    document.addEventListener('click', (event) => {
        const target = event.target as Element | null;
        closeAll(target?.closest('details.language-select') ?? null);
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            closeAll();
        }
    });
}
